export default "<p>edit-material-modal works!</p>\r\n"